module.exports = __webpack_public_path__ + "static/media/tags-empty.73422e25.svg";